import { Avatar } from '@/components/Avatar'
import { RichText } from '@/components/RichText'
import { BaseComposeModal } from '@/components/BaseComposeModal'
import { strings } from '@/strings'
import type { ReplyContext } from '@/types/posts'

interface ReplyModalProps {
    isOpen: boolean
    onClose: () => void
    replyContext: ReplyContext
}

export function ReplyModal({ isOpen, onClose, replyContext }: ReplyModalProps) {
    const parentAuthor = replyContext.parentPost.author

    return (
        <BaseComposeModal
            isOpen={isOpen}
            onClose={onClose}
            submitLabel={strings.posts.reply}
            placeholder={strings.compose.replyPlaceholder}
            replyTo={replyContext}
        >
            {/* Parent post preview */}
            <div className="px-4 pt-3 pb-1">
                <div className="flex gap-3">
                    <div className="flex flex-col items-center">
                        <Avatar
                            src={parentAuthor?.avatarUrl}
                            alt={parentAuthor?.handle ?? 'user'}
                            size="sm"
                        />
                        <div className="w-0.5 flex-1 bg-border-light dark:bg-border-dark mt-1" />
                    </div>
                    <div className="min-w-0 flex-1 pb-2">
                        <p className="text-sm font-semibold text-text-primary-light dark:text-text-primary-dark">
                            {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty displayName should fall back to handle, not render blank */}
                            {parentAuthor?.displayName || parentAuthor?.handle}
                        </p>
                        <div className="mt-0.5 text-sm text-text-secondary-light dark:text-text-secondary-dark">
                            <RichText text={replyContext.parentPost.text} />
                        </div>
                    </div>
                </div>
            </div>
        </BaseComposeModal>
    )
}
